// TalkRatioCard.js
import { Box, Paper } from "@mui/material";
import React from "react";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";

const TalkRatioCard = ({ data, colours, FONT }) => {
  const agentTalkTime = data?.analyticshits?.agenttalktime || 0;
  const clientTalkTime = data?.analyticshits?.clienttalktime || 0;
  const silenceTime = data?.analyticshits?.silence || 0;
  const totalTime = agentTalkTime + clientTalkTime + silenceTime;

  // Calculate percentages with a fallback to 0 if totalTime is 0
  const agentPercentage = totalTime ? ((agentTalkTime / totalTime) * 100).toFixed(0) : 0;
  const clientPercentage = totalTime ? ((clientTalkTime / totalTime) * 100).toFixed(0) : 0;
  const silencePercentage = totalTime ? ((silenceTime / totalTime) * 100).toFixed(0) : 0;

  return (
    <Paper
      sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
    >
      <CardHeaderTitle
        title="Talk Ratio"
        tooltip="The ratio between Agent speaking time, Client speaking time, and silence in a recording."
      />

      <Box marginTop={2} display="flex" flexDirection="row" gap={1} textAlign="center">
        <Box>
          <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{agentPercentage}</div>
          <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
            Agent
          </div>
        </Box>
        <Box>
          <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>:</div>
        </Box>
        <Box>
          <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{clientPercentage}</div>
          <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
            Client
          </div>
        </Box>
        <Box>
          <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>:</div>
        </Box>
        <Box>
          <div style={{ fontSize: FONT.SIZE_20, fontWeight: "600" }}>{silencePercentage}</div>
          <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>
            Silence
          </div>
        </Box>
      </Box>
    </Paper>
  );
};

export default TalkRatioCard;